import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { setActiveStep, preSaveConfiguration, clearSoftwareLicenses, removeSoftwareLicence, cancelConfiguration } from '../../configuration-management/ducks';
import { configurationStatuses, softwareStepsConfig, stepsConfig, SUBSTITUTION_TYPE_REPLACE } from '../../../constants';
import Button from '../../../atoms/button';
import ApplicationFullHeader from '../../../components/application_full_header';
import I10n from '../../i10n';
import { appConfiguration } from '../../../utils/app-starter';
import { getSoftwareStepperLabels } from '../../../utils/linear-stepper';
import { setServicePlanActivationServicePlanScreen } from '../../configuration-management/ducks';
import MsxIcons from '../../msx-icons';
import { openModal, closeModal} from '../../modals/ducks';
import { setApplicationParameters } from '../../../utils/application-parameters/ducks';
import { buildMySchneiderUrl } from '../../../utils/url-builder';
import { showNotificationWithButton } from '../../notification/ducks';
import Configuration from '../../../models/Configuration';
import { buildLicenseGroups } from '../../../utils/software-licenses';
import ServicePlanScreenContent from '../../../components/software_licence/service_plan_screen_content';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-x: hidden;
  background-color: #F4F4F4;
  @media (max-width: 800px) {
    position: fixed;
    z-index: 300;
    top: 0px;left: 0px;right:0px;bottom: 0px;
    padding: 0px;
  }
  ${props => props.fullScreenEnabled && `
    position: fixed;
    z-index: 300;
    top: 0px;left: 0px;right:0px;bottom: 0px;
    padding: 0px;
  `}
`;

const WrapperAndNavigation = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
`;

const FullScreenNavigationButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 5px;
  position: fixed;
  bottom: 0; left: 0; right: 0;
  transform: translate3d(0,0,0);
  border-top: 2px solid #EDEDED;
  background-color: white;
`;

const HiddenNavigationButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 5px;
  background-color: white;
  border-top: 2px solid #EDEDED;
  visibility: hidden;
  margin-top: 10px;
`;

const OutdatedLicenseModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const OutdatedLicenseModalLabel = styled.span`
  margin-bottom: 10px;
`;

const OutdatedLicenseModalRowLabel = styled.span`
  margin-bottom: 5px;
`;

const MobilePackageSummaryWrapper = styled.div`
  display: none;
  padding: 10px;
  justify-content: space-between;
  align-items: center;
  background-color: #FFFFFF;
  cursor: pointer;

  ${props => props.$isOpen ? '' : 'box-shadow: 0px 2px 16px 0px #00000040;'}

  @media (max-width: 800px) {
    display: flex;
  }
`;

const MobilePackageSupparyLabel = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: #000000;
`;

const MobileChipAndIconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const MobileIconWrapper = styled.div`
  transition: transform 0.3s;
  transform: ${(props) => (props.$isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  margin-left: 10px;
  cursor: pointer;
`;

const Counter = styled.div`
  background-color: #2E3638;
  color: white;
  display: inline-block;
  line-height: 0px;
  border-radius: 50%;
  font-size: 16px;
  font-weight: 400;
`;

const CounterLabel = styled.div`
  display: inline-block;
  padding-top: 50%;
  padding-bottom: 50%;
  margin-left: 8px;
  margin-right: 8px;
`;

const CancelWrapper = styled.div`
  margin-right: 10px;
`;

class ServicePlanScreen extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      isDesktop: window.innerWidth > 800,
      mobilePackageSummaryOpen: false,
    };
    this._isMounted = false;
  }

  updateIsDesktop = () => {
    if (this.state.isDesktop && window.innerWidth <= 800) {
      this.setState({ isDesktop: false });
    } else if (!this.state.isDesktop && window.innerWidth > 800) {
      this.setState({ isDesktop: true });
    }
  }

  componentDidMount = () => {
    window.addEventListener("resize", this.updateIsDesktop);
    this._isMounted = true;
    if (this.props.configuration.status === configurationStatuses.finished && (this.props.configuration.outdatedLicenses || []).length > 0) {
      // Ask for license migration
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => {
            this.props.closeModal();
            this.props.setActiveStep(stepsConfig.save_screen);
          },
          onSubmit: () => {
            this.props.closeModal();
            this.props.updateMsxSoftwareLicenseReferences(this.props.configuration);
          },
          title: I10n.get('screen.licence_selector.outdated_licences.modal.title'),
          text: this.buildOutdatedLicensesModalContent(),
          cancelText: I10n.get('app.action.no'),
          submitText: I10n.get('app.action.yes')
        }
      });
    }
  }


  componentWillUnmount = () => {
    window.removeEventListener("resize", this.updateIsDesktop);
  }

  updateStateIfMounted(state) {
    if (this._isMounted) {
      this.setState(state);
    }
  }

  confirmationBeforeCancel = (isSaved, cancelCallback) => {
    if (!isSaved) {
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => {
            this.props.closeModal();
          },
          onSubmit: () => {
            cancelCallback();
            this.props.cancelConfiguration(this.props.configuration.id);
            this.props.closeModal();
          },
          title: I10n.get('screen.config_editor.modal_cancel.title'),
          text: I10n.get('screen.config_editor.modal_cancel.body'),
          cancelText: I10n.get('app.action.return'),
          submitText: I10n.get('app.action.confirm'),
        }
      });
    } else {
      cancelCallback();
    }
  }

  onContinue = () => {
    if (configurationStatuses.finished === this.props.configuration.status) {
      this.props.setActiveStep(stepsConfig.save_screen);
    } else {
      this.props.saveConfiguration(this.props.configuration).then(() => {
        this.props.showNotification(I10n.get('saved_configuration.configuration_saved'), 'success', null);
      }).catch(() => {
      });
      this.props.closeModal();
    }
  }

  renderNavigationButtonSection = () => {
    const buttons = <>
      <CancelWrapper>
        <Button
          id='license-selector-screen-back-button'
          disabled={this.props.configurationSaver.isSaving}
          onClick={event => {
            this.props.setActiveStep(softwareStepsConfig.licence_selector);
          }}
        >
          {I10n.get('app.action.back')}
        </Button>
      </CancelWrapper>
      <Button
        importance="emphasized"
        primary
        disabled={this.props.configurationSaver.isSaving}
        onClick={event => {
          this.onContinue();
        }}>
          {I10n.get('app.action.continue')}
      </Button>
    </>;
    return (
      <>
        <FullScreenNavigationButtonSection>
          {buttons}
        </FullScreenNavigationButtonSection>
        <HiddenNavigationButtonSection>
          {buttons}
        </HiddenNavigationButtonSection>
      </>
    );
  }

  buildOutdatedLicensesModalContent = () => {
    return (<OutdatedLicenseModalContentWrapper>
      <OutdatedLicenseModalLabel>
        {I10n.get('screen.licence_selector.outdated_licences.modal.body')}
      </OutdatedLicenseModalLabel>
      {this.props.configuration.outdatedLicenses.map((outdatedItem, idx) => {
        if (outdatedItem.outdatedType === SUBSTITUTION_TYPE_REPLACE) {
          return <OutdatedLicenseModalRowLabel key={idx}>{I10n.getAndReplaceMultiple('screen.licence_selector.outdated_licences.modal.updated', [outdatedItem.oldLicense, outdatedItem.newLicense])}</OutdatedLicenseModalRowLabel>;
        }
        return <OutdatedLicenseModalRowLabel key={idx}>{I10n.getAndReplace('screen.licence_selector.outdated_licences.modal.removed', outdatedItem.oldLicense)}</OutdatedLicenseModalRowLabel>;
      })}
    </OutdatedLicenseModalContentWrapper>);
  }

  showDuplicateConfirmationModal = (callback) => {
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    if (isSaved && !this.props.configuration.allowSavedModifications) {
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => { this.props.closeModal(); },
          onSubmit: () => {
            this.props.closeModal();
            callback();
          },
          title: I10n.get('modal.change_saved_configuration.title'),
          text: I10n.get('modal.change_saved_configuration.body'),
          cancelText: I10n.get('app.action.cancel'),
          submitText: I10n.get('app.action.continue'),
        }
      });
    } else {
      callback();
    }
  }


  removeSoftwareLicence = (licence, cancelCallback) => {
    this.showDuplicateConfirmationModal(() => {
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => { if (cancelCallback) { cancelCallback(); } this.props.closeModal(); },
          onSubmit: () => {
            this.props.closeModal();
            this.props.removeSoftwareLicence(licence);
          },
          title: I10n.get('screen.licence_selector.remove_licence.modal.title'),
          text: I10n.get('screen.licence_selector.remove_licence.modal.body'),
          cancelText: I10n.get('app.action.cancel'),
          submitText: I10n.get('app.action.continue'),
        }
      });
    });
  }

  getStepperActions = (isSaved) => {
    return [
      {
        action: () => {
          this.props.setActiveStep(softwareStepsConfig.software_selection);
        }, active: true, done: true },
      { action: () => {
          this.props.setActiveStep(softwareStepsConfig.licence_selector);
      }, active: true, done: true },
      { action: () => {}, active: true, done: isSaved },
      {
        action: () => {
          if (configurationStatuses.finished === this.props.configuration.status) {
            this.props.setActiveStep(softwareStepsConfig.save_screen);
          } else {
            this.props.saveConfiguration(this.props.configuration).then(() => {
              this.props.showNotification(I10n.get('saved_configuration.configuration_saved'), 'success', null);
            }).catch(() => { });
            this.props.closeModal();
          }
        }, active: true , done: isSaved
      }
    ]
  };

  render() {
    const config = new Configuration(this.props.configuration);
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    const canRemove = [...config.softwareLicences].length > 1;
    const licensesToShow = [...config.softwareLicences]
      .map(license => {return {
          ...license,
          canRemove,
          quantityLabel: I10n.get('bom.qty')
        };
      })
      .sort((a,b) => a.order - b.order);

    if (config.servicePlanActivated) {
      licensesToShow.push(...[...config.servicePlanItems].map(servicePlanItem => {
        return {
          ...servicePlanItem,
          quantityLabel: I10n.get('bom.service_plan_size'),
          ignoreGlobalQuantity: true
        };
      }));
    }

    const licenseGroupsForSummary = buildLicenseGroups(licensesToShow.sort((a,b) => a.order - b.order));
    const nbLicensesAdded = licenseGroupsForSummary.flatMap(licenseGroup => {
      return licenseGroup.licences.map(license => license);
    })
    .filter(licence => licence.ignoreGlobalQuantity == null || licence.ignoreGlobalQuantity === false)
    .reduce((accumulator, license) => {
      return accumulator + license.quantity;
    }, 0);

    return (
      <Container fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
        <ApplicationFullHeader
          title= {I10n.get('app.licence_selector.title')}
          fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}
          shouldShowLogin={appConfiguration.seamlessSession == null}
          userName={appConfiguration.seamlessSession?.name}
          applicationParameters={this.props.applicationParameters}
          setApplicationParameters={this.props.setApplicationParameters}
          steps={getSoftwareStepperLabels()}
          activeStep={softwareStepsConfig.service_plan}
          goToStartPage={
            () => {
              this.confirmationBeforeCancel(isSaved, this.props.backToStart);
            }}
          stepperActions={this.getStepperActions(isSaved)}
          openModal={this.props.openModal}
          closeModal={this.props.closeModal}
          disabled={this.props.configurationSaver.isSaving}
          redirectWithCBR={false}
          mySchneiderLink={buildMySchneiderUrl()}
          isSoftwareLicenseConfiguration={true}
        />
        <MobilePackageSummaryWrapper $isOpen={this.state.mobilePackageSummaryOpen} onClick={() => {
          this.updateStateIfMounted({mobilePackageSummaryOpen: !this.state.mobilePackageSummaryOpen});
        }}>
          <MobilePackageSupparyLabel>{I10n.get("screen.licence_selector.package_summary")}</MobilePackageSupparyLabel>
          <MobileChipAndIconWrapper>
            <Counter><CounterLabel>{nbLicensesAdded >= 100 ? '99+' : nbLicensesAdded }</CounterLabel></Counter>
            <MobileIconWrapper $isOpen={this.state.mobilePackageSummaryOpen}>
              <MsxIcons name="down-arrow"></MsxIcons>
            </MobileIconWrapper>
          </MobileChipAndIconWrapper>
        </MobilePackageSummaryWrapper>
        <WrapperAndNavigation>
          <ServicePlanScreenContent
            softwareInfo={config.softwareInfo}
            licenseModel={config.licenseModel}
            servicePlanItems={config.servicePlanItems}
            servicePlanActivated={config.servicePlanActivated}
            licenseGroupsForSummary={licenseGroupsForSummary}
            setServicePlanActivationServicePlanScreen={(newStatus) => {
              return this.props.setServicePlanActivationServicePlanScreen(!config.servicePlanActivated);

            }}
            removeSoftwareLicence={this.removeSoftwareLicence}
            clearSoftwareLicenses={() => {
              return this.props.clearSoftwareLicenses().then(() => {
                this.props.closeModal();
              });
            }}
            openModal={this.props.openModal}
            closeModal={this.props.closeModal}
            onContinue={() => {
              this.props.closeModal();
            }}
            mobilePackageSummaryOpen={this.state.mobilePackageSummaryOpen}
            isSaving={this.props.configurationSaver.isSaving}
          ></ServicePlanScreenContent>
          {this.renderNavigationButtonSection()}
        </WrapperAndNavigation>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setActiveStep: (step) => dispatch(setActiveStep(step)),
    backToStart: () => dispatch(setActiveStep(stepsConfig.start_screen)),
    setServicePlanActivationServicePlanScreen: (newStatus) => dispatch(setServicePlanActivationServicePlanScreen(newStatus)),
    removeSoftwareLicence: (licence) => dispatch(removeSoftwareLicence(licence)),
    saveConfiguration: (configuration) => dispatch(preSaveConfiguration(configuration)),
    cancelConfiguration: (configId) => dispatch(cancelConfiguration(configId)),
    openModal: (modalTypeWithProps) => dispatch(openModal(modalTypeWithProps)),
    closeModal: () => dispatch(closeModal()),
    setApplicationParameters: (parameters) => dispatch(setApplicationParameters(parameters)),
    showNotification: (text, type, buttonElement) => dispatch(showNotificationWithButton(text, type, buttonElement)),
    clearSoftwareLicenses: () => dispatch(clearSoftwareLicenses())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ServicePlanScreen);
